<div class="bg_img">
  <div class="wp_music" (click)="playSong()">
    <img src="assets/music.png" alt="">
    <audio loop id="myAudio">
      <source src="assets/Theme.mp3" type="audio/mp3">
    </audio>
  </div>

  <div class="wp_image">
    <img src="assets/akinator.png" alt="">
  </div>
  <div class="wp_btn-play">
    <div class="btn-play" (click)="startGame()">
      <span class="text-play">
        <span >♦♦</span>
        PLAY
        <span>♦♦</span>
      </span>
    </div>

  </div>
</div>